function height() {
  var t = $(
    ".design_2 .product-block .image,.design_5 .product-block .image,.design_1 .product-single__thumbs a.product-single__thumbnail img,.design_3 .product-single__thumbs a.product-single__thumbnail img"
  ).height();
  $(
    ".design_2 .product-block .extra-video,.design_5 .product-block .extra-video,.design_1 .product-single__thumbs a.product-single__thumbnail.extra-video img,.design_3 .product-single__thumbs a.product-single__thumbnail.extra-video img"
  ).height(t),
    $(
      ".design_2 .product-block .video,.design_5 .product-block .video,.design_1 .product-single__thumbs a.product-single__thumbnail.video img,.design_3 .product-single__thumbs a.product-single__thumbnail.video img"
    ).height(t),
    $(
      ".design_2 .product-block .model,.design_5 .product-block .model,.design_1 .product-single__thumbs a.product-single__thumbnail.model img,.design_3 .product-single__thumbs a.product-single__thumbnail.model img"
    ).height(t);
}
function productcartsticky() {
  jQuery(window).width() > 319 && jQuery(this).scrollTop() > 550
    ? jQuery(".add-to-cart-sticky").addClass("fixed")
    : jQuery(".add-to-cart-sticky").removeClass("fixed");
}
function footerToggle() {
  992 > jQuery(window).width()
    ? (jQuery(".left-sidebar.sidebar").insertAfter(".collection_wrapper"),
      jQuery(
        ".right-sidebar.sidebar .widget > h4,.left-sidebar.sidebar .widget > h4,.blog-section .sidebar .widget > h4"
      ).addClass("toggle"),
      jQuery(
        ".right-sidebar.sidebar .widget,.left-sidebar.sidebar .widget,.blog-section .sidebar .widget"
      )
        .children(":nth-child(2)")
        .css("display", "none"),
      jQuery(
        ".right-sidebar.sidebar .widget.active,.left-sidebar.sidebar .widget.active,.blog-section .sidebar .widget.active"
      )
        .children(":nth-child(2)")
        .css("display", "block"),
      jQuery(
        ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
      ).unbind("click"),
      jQuery(
        ".right-sidebar.sidebar .widget > h4.toggle,.left-sidebar.sidebar .widget > h4.toggle,.blog-section .sidebar .widget > h4.toggle"
      ).on("click", function () {
        jQuery(this)
          .parent()
          .toggleClass("active")
          .children(":nth-child(2)")
          .slideToggle("fast");
      }),
      jQuery(
        ".collection_right .sidebar-block .widget > h4,.collection_left .sidebar-block .widget > h4,.filter-toggle-wrap .sidebar-block .widget > h4"
      ).addClass("toggle"),
      jQuery(
        ".collection_right .sidebar-block .widget,.collection_left .sidebar-block .widget,.filter-toggle-wrap .sidebar-block .widget "
      )
        .children(":nth-child(2)")
        .css("display", "none"),
      jQuery(
        ".collection_right .sidebar-block .widget.active,.collection_left .sidebar-block .widget.active,.filter-toggle-wrap .sidebar-block .widget.active"
      )
        .children(":nth-child(2)")
        .css("display", "block"),
      jQuery(
        ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
      ).unbind("click"),
      jQuery(
        ".collection_right .sidebar-block .widget > h4.toggle,.collection_left .sidebar-block .widget > h4.toggle,.filter-toggle-wrap .sidebar-block .widget > h4.toggle"
      ).on("click", function () {
        jQuery(this)
          .parent()
          .toggleClass("active")
          .children(":nth-child(2)")
          .slideToggle("fast");
      }))
    : (jQuery(".left-sidebar.sidebar").insertBefore(".collection_wrapper"),
      jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").unbind(
        "click"
      ),
      jQuery(".sidebar .widget > h4,.sidebar-block .widget > h4").removeClass(
        "toggle"
      ),
      jQuery(".sidebar .widget,.sidebar-block .widget")
        .children(":nth-child(2)")
        .css("display", "block"));
}
function splitStr(t, s) {
  return t.split(s);
}
function countDownIni(t) {
  $(t).each(function () {
    var t,
      s = $(this);
    s.attr("data-promoperiod")
      ? (t = new Date().getTime() + parseInt(s.attr("data-promoperiod"), 10))
      : s.attr("data-countdown") && (t = s.attr("data-countdown")),
      Date.parse(t) - Date.parse(new Date()) > 0 &&
        ($(this).parent(".simple-countdown").addClass("countdown-block"),
        s.countdown(t, function (t) {
          s.html(
            t.strftime(
              '<span><span class="left-txt">Left</span><span>%D</span><span class="time-txt">Days</span></span><span><span>%H</span><span class="time-txt">Hrs</span></span><span><span>%M</span><span class="time-txt">Min</span></span><span><span class="second">%S</span><span class="time-txt">Sec</span></span>'
            )
          );
        }));
  });
}
function hb_animated_contents() {
  $(".hb-animate-element:in-viewport").each(function (t) {
    var s = $(this);
    s.hasClass("hb-in-viewport") ||
      setTimeout(function () {
        s.addClass("hb-in-viewport");
      }, 180 * t);
  });
}
function sidebarsticky() {
  1199 >= $(document).width()
    ? jQuery(
        ".left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left"
      ).theiaStickySidebar({
        additionalMarginBottom: 30,
        additionalMarginTop: 30,
      })
    : $(document).width() >= 1200 &&
      jQuery(
        ".left-sidebar.sidebar,.right-sidebar.sidebar,.collection_right,.collection_left"
      ).theiaStickySidebar({
        additionalMarginBottom: 30,
        additionalMarginTop: 130,
      });
}
$(document).ready(function () {
  jQuery(".dt-menu-expand").on("click", function (event) {
    return (
      event.preventDefault(),
      $(this).hasClass("dt-mean-clicked")
        ? ($(this).text("+"),
          $(this).prev("ul").length
            ? $(this).prev("ul").slideUp(400)
            : $(this)
                .prev(".megamenu-child-container")
                .find("ul:first")
                .slideUp(600))
        : ($(this).text("--"),
          $(this).prev("ul").length
            ? $(this).prev("ul").slideDown(400)
            : $(this)
                .prev(".megamenu-child-container")
                .find("ul:first")
                .slideDown(2e3)),
      $(this).toggleClass("dt-mean-clicked"),
      !1
    );
  }),
    AOS.init({ duration: 1200 }),
    jQuery(".special-collection,.ttproduct").wrapAll(
      '<div class="main-product"><div class="container"></div></div>'
    ),
    jQuery("#GotoTop").on("click", function () {
      return jQuery("html, body").animate({ scrollTop: 0 }, "1000"), !1;
    }),
    jQuery(".nav-toggle").click(function (t) {
      jQuery(this).toggleClass("active"),
        t.stopPropagation(),
        jQuery("#tt-megamenu .tt-mega_menu").slideToggle("2000"),
        jQuery("body").toggleClass("open-header");
    }),
    jQuery("#tt-megamenu .tt-mega_menu").on("click", function (t) {
      t.stopPropagation(), jQuery(this).removeClass("active");
    }),
    jQuery("#tt-megamenu1 li.tt_menu_item.tt_mm_hassub").hover(
      function () {
        jQuery("body").addClass("menu-open");
      },
      function () {
        jQuery("body").removeClass("menu-open");
      }
    ),
    jQuery(".dark-light-mode .dark-mode").on("click", function (t) {
      jQuery("body").addClass("darkmode");
    }),
    jQuery(".dark-light-mode .light-mode").on("click", function (t) {
      jQuery("body").removeClass("darkmode");
    }),
    jQuery(".cart-footer-actions .cart-note").on("click", function (t) {
      jQuery(".mini-cart-footer .note-detail").addClass("open");
    }),
    jQuery(
      ".fixed-cart-wrap,.note-detail .text-cancle,.note-detail .text-save"
    ).click(function () {
      jQuery(".mini-cart-footer .note-detail").removeClass("open");
    }),
    jQuery(".cart-footer-actions .coupen-code").on("click", function (t) {
      jQuery(".mini-cart-footer .discount-code").addClass("open");
    }),
    jQuery(
      ".fixed-cart-wrap,.discount-code .text-cancle,.discount-code .text-save"
    ).click(function () {
      jQuery(".mini-cart-footer .discount-code").removeClass("open");
    }),
    $(".demo-heading").on("click", function (t) {
      t.preventDefault(), $("#shopify-section-demo-list").toggleClass("active");
    }),
    $(".demos-close-icon").on("click", function (t) {
      $("#shopify-section-demo-list").removeClass("active");
    }),
    jQuery(".enable-light").on("click", function (t) {
      jQuery(".enable-light").removeClass("active"),
        jQuery(".enable-dark").addClass("active"),
        jQuery("body").removeClass("darkmode");
    }),
    jQuery(".enable-dark").on("click", function (t) {
      jQuery(".enable-light").addClass("active"),
        jQuery(".enable-dark").removeClass("active"),
        jQuery("body").addClass("darkmode");
    }),
    jQuery(".filter-toggle").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).toggleClass("active"),
        jQuery(".filter-toggle-wrap").slideToggle("is-visible");
    }),
    jQuery(".product-single__thumbs img").on("click", function () {
      var t = jQuery(this).attr("src");
      "" != t &&
        jQuery(this)
          .closest(".product-wrapper")
          .find("img.grid-view-item__image")
          .first()
          .attr("src", t),
        jQuery(this)
          .parent(".grid-item")
          .addClass("open")
          .siblings(".grid-item")
          .removeClass("open");
    });
  var t = jQuery(".popup_overlay");
  function s(t) {
    var s = document
      .getElementById("popupVid")
      .getElementsByTagName("iframe")[0].contentWindow;
    (func = "hide" == t ? "pauseVideo" : "playVideo"),
      s.postMessage('{"event":"command","func":"' + func + '","args":""}', "*");
  }
  function i() {
    $(".toggle_menu").hasClass("current-open") &&
      $(".sticky_header").hasClass("fixed") &&
      ($(".toggle_menu").addClass("current-close"),
      $("body").removeClass("menu-current-open"),
      $(".toggle_menu").removeClass("current-open"),
      $(".tt-mega_menu").slideToggle("2000"));
  }
  jQuery(".play-icone").click(function () {
    jQuery("body").addClass("popup-toggle"), t.css("display", "block");
  }),
    t.click(function (s) {
      (e = s || window.event).target == this &&
        (jQuery(t).css("display", "none"),
        jQuery("body").removeClass("popup-toggle"));
    }),
    jQuery(".popup_close,.homeslider ul.slick-slider .slick-arrow").click(
      function () {
        t.css("display", "none"), jQuery("body").removeClass("popup-toggle");
      }
    ),
    $(document).ready(function () {
      i();
    }),
    $(window).resize(function () {
      i();
    }),
    $(window).scroll(function () {
      i();
    }),
    jQuery(".play-icone, .homeslider ul.slick-slider .slick-arrow").click(
      function () {
        t.css("visibility", "visible").css("opacity", "1");
      }
    ),
    t.click(function (i) {
      (e = i || window.event).target == this &&
        (jQuery(t).css("visibility", "hidden").css("opacity", "0"), s("hide"));
    }),
    jQuery(".popup_close").click(function () {
      t.css("visibility", "hidden").css("opacity", "0"), s("hide");
    });
  var o = jQuery(".about-videoblock .popup_overlay");
  function a(t) {
    var s = document
      .getElementById("popupVid")
      .getElementsByTagName("iframe")[0].contentWindow;
    (func = "hide" == t ? "pauseVideo" : "playVideo"),
      s.postMessage('{"event":"command","func":"' + func + '","args":""}', "*");
  }
  jQuery(".about-videoblock #popup_toggle").click(function () {
    jQuery("body").addClass("popup-toggle1"), o.css("display", "block");
  }),
    o.click(function (t) {
      (e = t || window.event).target == this &&
        (jQuery(o).css("display", "none"),
        jQuery("body").removeClass("popup-toggle1"));
    }),
    jQuery(".about-videoblock .popup_close").click(function () {
      o.css("display", "none"), jQuery("body").removeClass("popup-toggle1");
    }),
    jQuery(".about-videoblock #popup_toggle").click(function () {
      o.css("visibility", "visible").css("opacity", "1");
    }),
    o.click(function (t) {
      (e = t || window.event).target == this &&
        (jQuery(o).css("visibility", "hidden").css("opacity", "0"), a("hide"));
    }),
    jQuery(".about-videoblock .popup_close").click(function () {
      o.css("visibility", "hidden").css("opacity", "0"), a("hide");
    }),
    jQuery(".shopify-payment-button .shopify-payment-button__button").prepend(
      jQuery("<i class='mdi mdi-cart-outline'></i>")
    ),
    jQuery(".header_1 .wrapper-wrap").hasClass("logo_center") &&
      jQuery("body").addClass("logo_center");
  var l = $(window).width();
  $(".slider-content-main-wrap").css("width", l),
    $(".site-header").hasClass("header_transaparent") &&
      $("body.template-index").addClass("header_transaparent");
  var n = jQuery(".product-single__thumbs .slick-active.slick-current")
    .find(".product-single__thumb")
    .data("id");
  jQuery(".product-lightbox-btn").hasClass(n) &&
    jQuery(".product-lightbox-btn." + n).show(),
    jQuery(".filter-left").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).toggleClass("active"),
        jQuery(".off-canvas.position-left").addClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
          "is-visible is-closable"
        );
    }),
    jQuery(".filter-right").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).toggleClass("active"),
        jQuery(".off-canvas.position-right").addClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").addClass(
          "is-visible is-closable"
        );
    }),
    jQuery(".off-canvas .sidebar_close").on("click", function (t) {
      t.preventDefault(),
        jQuery(".off-canvas.position-left").removeClass("is-open"),
        jQuery(".off-canvas.position-right").removeClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
          "is-visible is-closable"
        );
    }),
    jQuery(".is-overlay-fixed").on("click", function (t) {
      t.preventDefault(),
        jQuery(".filter-left").trigger("click"),
        jQuery(".filter-right").trigger("click"),
        jQuery(".off-canvas.position-left").removeClass("is-open"),
        jQuery(".off-canvas.position-right").removeClass("is-open"),
        jQuery(".js-off-canvas-overlay.is-overlay-fixed").removeClass(
          "is-visible is-closable"
        );
    }),
    $(".product-360-button a").magnificPopup({
      type: "inline",
      mainClass: "mfp-fade",
      removalDelay: 160,
      disableOn: !1,
      preloader: !1,
      fixedContentPos: !1,
      callbacks: {
        open: function () {
          $(window).resize();
        },
      },
    }),
    countDownIni(".flip-countdown,.js-flip-countdown"),
    $(".popup-video").magnificPopup({
      disableOn: 300,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: !1,
      fixedContentPos: !1,
    }),
    ($("a.product-lightbox-btn").length > 0 ||
      $("a.product-video-popup").length > 0) &&
      $(
        ".product-single__photos .gallery,.design_2 .product-img"
      ).magnificPopup({
        delegate: "a",
        type: "image",
        tLoading:
          '<div class="please-wait dark"><span></span><span></span><span></span></div>',
        removalDelay: 300,
        closeOnContentClick: !0,
        gallery: { enabled: !0, navigateByImgClick: !1, preload: [0, 1] },
        image: {
          verticalFit: !1,
          tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
        },
        callbacks: {
          beforeOpen: function () {
            var t = $(".product-video-popup").attr("href");
            if (t) {
              this.st.mainClass = "has-product-video";
              var s = $.magnificPopup.instance;
              s.items.push({ src: t, type: "iframe" }), s.updateItemHTML();
            }
          },
          open: function () {},
        },
      }),
    $(".design_3 .product-img,.design_5 .pro_img").magnificPopup({
      delegate: "a",
      type: "image",
      tLoading:
        '<div class="please-wait dark"><span></span><span></span><span></span></div>',
      removalDelay: 300,
      closeOnContentClick: !0,
      gallery: { enabled: !0, navigateByImgClick: !1, preload: [0, 1] },
      image: {
        verticalFit: !1,
        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      },
      callbacks: {
        beforeOpen: function () {
          var t = $(".product-video-popup").attr("href");
          if (t) {
            this.st.mainClass = "has-product-video";
            var s = $.magnificPopup.instance;
            s.items.push({ src: t, type: "iframe" }), s.updateItemHTML();
          }
        },
        open: function () {},
      },
    }),
    $("body").on("click", ".product-lightbox-btn", function (t) {
      $(".product-wrapper-owlslider").find(".owl-item.active a").click(),
        t.preventDefault();
    }),
    $(".product-layouts .qtyplus").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).parents(".qty-box-set").find(".quantity");
      var s = parseInt(
        jQuery(this).parents(".qty-box-set").find(".quantity").val()
      );
      isNaN(s)
        ? jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
        : jQuery(this)
            .parents(".qty-box-set")
            .find(".quantity")
            .val(s + 1);
    }),
    $(".product-layouts .qtyminus").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).parents(".qty-box-set").find(".quantity");
      var s = parseInt(
        jQuery(this).parents(".qty-box-set").find(".quantity").val()
      );
      !isNaN(s) && s > 1
        ? jQuery(this)
            .closest(".qty-box-set")
            .find(".quantity")
            .val(s - 1)
        : jQuery(this).closest(".qty-box-set").find(".quantity").val(1);
    }),
    $(".sticky-data .product-qty .qtyplus").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).parents(".qty-box-set").find(".quantity");
      var s = parseInt(
        jQuery(this).parents(".qty-box-set").find(".quantity").val()
      );
      isNaN(s)
        ? jQuery(this).parents(".qty-box-set").find(".quantity").val(1)
        : jQuery(this)
            .parents(".qty-box-set")
            .find(".quantity")
            .val(s + 1);
    }),
    $(".sticky-data .product-qty .qtyminus").on("click", function (t) {
      t.preventDefault(),
        jQuery(this).parents(".qty-box-set").find(".quantity");
      var s = parseInt(
        jQuery(this).parents(".qty-box-set").find(".quantity").val()
      );
      !isNaN(s) && s > 1
        ? jQuery(this)
            .closest(".qty-box-set")
            .find(".quantity")
            .val(s - 1)
        : jQuery(this).closest(".qty-box-set").find(".quantity").val(1);
    }),
    $("#navToggle").on("click", function (t) {
      jQuery(this).next(".Site-navigation").slideToggle(500);
    }),
    $(".menu_toggle_wrap #navToggle").on("click", function (t) {
      jQuery(this).parent().next(".Site-navigation").slideToggle(500);
    }),
    jQuery(".site-header__search.search-full .serach_icon").on(
      "click",
      function (t) {
        t.preventDefault(),
          jQuery(this).toggleClass("active"),
          jQuery("body").toggleClass("search_full_active"),
          jQuery(".search-full-screen").slideToggle("slow"),
          jQuery(".full-search-wrapper").addClass("search-overlap"),
          jQuery(".myaccount  .dropdown-toggle").removeClass("open"),
          jQuery(".myaccount  .customer_account").slideUp("fast"),
          jQuery(".site-header .site-header_cart_link").removeClass("active"),
          jQuery(".fixed-cart-wrap").removeClass("active"),
          jQuery(".search-bar > input").focus(),
          jQuery("body").toggleClass("search_toggle"),
          jQuery("body").removeClass("account-toggle"),
          jQuery("body").removeClass("cart_toggle");
      }
    ),
    jQuery(".site-header__search.search-full .close-search").on(
      "click",
      function () {
        jQuery(".site-header__search.search-full .serach_icon").removeClass(
          "active"
        ),
          jQuery(".full-search-wrapper").removeClass("search-overlap"),
          jQuery(".full-search-wrapper").removeClass("search-overlap"),
          jQuery(".header_3 .search-full-screen").removeClass("active"),
          jQuery("body").removeClass("search_full_active"),
          jQuery("body").removeClass("search_toggle"),
          jQuery(".search-full-screen").slideUp("slow");
      }
    ),
    jQuery(".site-header__search:not(.search-full) .serach_icon").on(
      "click",
      function () {
        jQuery(".search_wrapper").slideToggle("fast"),
          jQuery(".search-bar > input").focus(),
          jQuery(this).toggleClass("active"),
          jQuery("body").toggleClass("search_toggle"),
          jQuery(".site-header .site-header_cart_link").removeClass("active"),
          jQuery(".myaccount  .dropdown-toggle").removeClass("open"),
          jQuery(".myaccount  .customer_account").slideUp("fast"),
          jQuery(".fixed-cart-wrap").removeClass("active"),
          jQuery("body").removeClass("account-toggle"),
          jQuery("body").removeClass("cart_toggle");
      }
    ),
    jQuery(".myaccount  span.dropdown-toggle").on("click", function (t) {
      t.preventDefault(),
        jQuery(".customer_account").slideToggle("fast"),
        jQuery(this).toggleClass("open"),
        jQuery("body").toggleClass("account-toggle"),
        jQuery("body").removeClass("currency-open"),
        jQuery("body").removeClass("language-open"),
        jQuery(".site-header .site-header_cart_link").removeClass("active"),
        jQuery(".fixed-cart-wrap").removeClass("active"),
        jQuery("body").removeClass("search_toggle"),
        jQuery("body").removeClass("cart_toggle");
    }),
    jQuery(".header_language .disclosure__toggle").on("click", function (t) {
      t.preventDefault(),
        jQuery(".customer_account").stop(),
        jQuery("body").toggleClass("language-open"),
        jQuery("body").removeClass("currency-open"),
        jQuery("body").removeClass("account-toggle"),
        jQuery("body").removeClass("myaccount_active"),
        jQuery("body").removeClass("cart_active"),
        jQuery(".currency_wrapper").removeClass("active"),
        jQuery(this).toggleClass("active"),
        jQuery(".customer_account").slideUp("fast"),
        jQuery(".disclosure-list").slideToggle("fast"),
        jQuery(".currencies.flag-dropdown-menu").slideUp("fast"),
        jQuery(".fixed-cart-wrap").removeClass("active");
    }),
    $(".header_currency .currency_wrapper.dropdown-toggle").on(
      "click",
      function (t) {
        t.preventDefault(),
          jQuery("body").toggleClass("currency-open"),
          jQuery("body").removeClass("language-open"),
          jQuery("body").removeClass("account-toggle"),
          jQuery("body").removeClass("myaccount_active"),
          jQuery("body").removeClass("cart_active"),
          jQuery(".disclosure__toggle").removeClass("active"),
          $(this).toggleClass("active"),
          jQuery(".customer_account").slideUp("fast"),
          jQuery(".header_language .disclosure-list").slideUp("fast"),
          jQuery(".currencies.flag-dropdown-menu").slideToggle("fast"),
          jQuery(".fixed-cart-wrap").removeClass("active");
      }
    ),
    jQuery(document).on("click", function (t) {
      var s = jQuery(".dropdown-toggle")[0],
        i = jQuery(".dropdown-toggle");
      i === t.target ||
        i.has(t.target).length ||
        s === t.target ||
        (jQuery(".customer_account").slideUp("fast"),
        jQuery("body").removeClass("account-toggle"),
        jQuery(".myaccount .dropdown-toggle").removeClass("open"));
      var o = jQuery("body .site-header__search")[0],
        a = jQuery("body .site-header__search");
      a === t.target ||
        a.has(t.target).length ||
        o === t.target ||
        (jQuery("body .search-full-screen").slideUp("slow"),
        jQuery("body").removeClass("search_full_active"),
        jQuery("body").removeClass("search_toggle"),
        jQuery("body .search_toggle").removeClass("active"));
      var l = jQuery(".language")[0],
        n = jQuery(".language");
      n === t.target ||
        n.has(t.target).length ||
        l === t.target ||
        (jQuery("#lang-list").slideUp("fast"),
        jQuery("body").removeClass("language-open"),
        jQuery(".language_wrapper").removeClass("active"));
      var r = jQuery(".currency")[0],
        c = jQuery(".currency");
      c === t.target ||
        c.has(t.target).length ||
        r === t.target ||
        (jQuery(".currencies").slideUp("fast"),
        jQuery("body").removeClass("currency-open"),
        jQuery(".currency_wrapper").removeClass("active"));
    });
  var r = $(".slider-mobile-gutter .product-grid");
  r.owlCarousel({
    items: 6,
    dots: !1,
    loop: !1,
    nav: !0,
    rewind: !1,
    autoplay: !1,
    responsive: {
      100: { items: 1 },
      315: { items: 2 },
      600: { items: 3 },
      992: { items: 4 },
      1300: { items: 6 },
    },
  }),
    window.matchMedia && window.matchMedia("(max-width: 767px)").matches &&
      setTimeout(function () {
        r.trigger("refresh.owl.carousel");
      }, 80),
    $(".slider-specialproduct .product-wrapper").each(function () {
      var t,
        s = $(this).find(".product-description .progress"),
        i = $(this).find(".quantity"),
        o = $(this).find(".progress-bar"),
        a = i.html(),
        l = parseInt(o.css("width")),
        n = parseInt(s.css("width")),
        r = l + parseInt(a);
      r > n && (r = n);
      var c = (r / n) * 100;
      o.animate({ width: c + "%" }, 100);
    }),
    $(".product-single").each(function () {
      var t,
        s = $(this).find(".product-information .progress"),
        i = $(this).find(".quantity"),
        o = $(this).find(".progress-bar"),
        a = i.html();
      var l = parseInt(o.css("width")),
        n = parseInt(s.css("width")),
        r = l + parseInt(a);
      r > n && (r = n);
      var c = (r / n) * 100;
      o.animate({ width: c + "%" }, 100);
    }),
    $(".product-thumb .slider-nav").owlCarousel({
      items: 1,
      dots: !1,
      loop: !0,
      nav: !0,
      rewind: !0,
      autoplay: !0,
      autoplayHoverPause: !0,
      responsive: {
        100: { items: 1 },
        481: { items: 1 },
        992: { items: 1 },
        1200: { items: 1 },
        1300: { items: 1 },
      },
    }),
    $(".block_content .cmsofferblock").owlCarousel({
      items: 7,
      nav: !1,
      dots: !1,
      loop: !1,
      autoplay: !1,
      responsive: {
        992: { items: 7 },
        544: { items: 2 },
        320: { items: 1 },
        100: { items: 1 },
      },
    }),
    $("body #footer-services .block_content").owlCarousel({
      items: 4,
      nav: !1,
      dots: !0,
      loop: !1,
      autoplay: !1,
      rewindNav: !0,
      responsive: {
        1200: { items: 4 },
        700: { items: 3 },
        481: { items: 2 },
        100: { items: 1 },
      },
    }),
    $("body .about-services .block_content").owlCarousel({
      items: 3,
      nav: !1,
      dots: !0,
      loop: !1,
      autoplay: !1,
      rewindNav: !0,
      responsive: {
        1200: { items: 3 },
        992: { items: 3 },
        481: { items: 2 },
        100: { items: 1 },
      },
    }),
    $("body .about-blog").owlCarousel({
      items: 3,
      nav: !1,
      dots: !0,
      loop: !1,
      autoplay: !1,
      rewindNav: !0,
      responsive: {
        1200: { items: 3 },
        992: { items: 3 },
        481: { items: 2 },
        100: { items: 1 },
      },
    }),
    $("body:not(.rtl) #tt-megamenu .list_product_menu_content").owlCarousel({
      items: 1,
      nav: !1,
      autoPlay: !0,
      autoplaySpeed: 1e3,
      stopOnHover: !1,
      loop: !1,
      dots: !0,
      responsive: { 768: { items: 1 }, 360: { items: 1 }, 100: { items: 1 } },
    }),
    $("body.rtl #tt-megamenu .list_product_menu_content").owlCarousel({
      items: 1,
      nav: !0,
      autoPlay: !0,
      autoplaySpeed: 1e3,
      rtl: !0,
      stopOnHover: !1,
      loop: !1,
      dots: !0,
      responsive: { 768: { items: 1 }, 360: { items: 1 }, 100: { items: 1 } },
    }),
    $("body:not(.rtl) .flash-sale .list_product_menu_content").owlCarousel({
      items: 7,
      nav: !0,
      autoPlay: !0,
      autoplaySpeed: 1e3,
      stopOnHover: !1,
      loop: !1,
      dots: !1,
      responsive: {
        1600: { items: 7 },
        1300: { items: 6 },
        1200: { items: 5 },
        992: { items: 4 },
        100: { items: 1 },
      },
    }),
    $("body.rtl .flash-sale .list_product_menu_content").owlCarousel({
      items: 7,
      nav: !0,
      autoPlay: !0,
      autoplaySpeed: 1e3,
      rtl: !0,
      stopOnHover: !1,
      loop: !1,
      dots: !1,
      responsive: {
        1600: { items: 7 },
        1300: { items: 6 },
        1200: { items: 5 },
        992: { items: 4 },
        100: { items: 1 },
      },
    }),
    $(".full_gallery_slider.owl-carousel").on(
      "changed.owl.carousel",
      function (t) {
        var s = t.target,
          i = t.item.count,
          o = t.relatedTarget.relative(t.item.index) + 1;
        $(s)
          .parent()
          .find(".num")
          .html(o + "/" + i);
      }
    ),
    $("body:not(.rtl) .full_gallery_slider.owl-carousel").owlCarousel({
      loop: !0,
      startPosition: 0,
      center: !0,
      dots: !0,
      items: 1,
      lazyLoad: !0,
      nav: !1,
      responsive: {
        100: { items: 1 },
        767: { items: 1 },
        991: { items: 3 },
        1199: { items: 3 },
        1299: { items: 3 },
      },
    }),
    $("body.rtl .full_gallery_slider.owl-carousel").owlCarousel({
      stagePadding: 200,
      loop: !0,
      startPosition: 0,
      center: !0,
      dots: !0,
      items: 1,
      rtl: !0,
      lazyLoad: !0,
      nav: !1,
      responsive: {
        0: { items: 1, stagePadding: 60 },
        600: { items: 1, stagePadding: 150 },
        768: { items: 1, stagePadding: 180 },
        868: { items: 1, stagePadding: 250 },
        1800: { items: 1, stagePadding: 300 },
      },
    }),
    $("body:not(.rtl) .tt-testimonial-wrap .testimonials_wrap").owlCarousel({
      items: 1,
      nav: !0,
      navText: [
        "<i class='mdi mdi-chevron-left'></i>",
        "<i class='mdi mdi-chevron-right'></i>",
      ],
      dots: !0,
      loop: !1,
      autoplay: !1,
      autoplayHoverPause: !0,
      responsive: { 1279: { items: 1 }, 1250: { items: 1 }, 600: { items: 1 } },
    }),
    $("body.rtl .tt-testimonial-wrap .testimonials_wrap").owlCarousel({
      items: 1,
      nav: !0,
      navText: [
        "<i class='mdi mdi-chevron-left'></i>",
        "<i class='mdi mdi-chevron-right'></i>",
      ],
      rtl: !0,
      dots: !0,
      autoplay: !1,
      loop: !1,
      autoplayHoverPause: !0,
      responsive: { 1279: { items: 1 }, 1250: { items: 1 }, 600: { items: 1 } },
    }),
    $(".product-single").each(function () {
      var t,
        s = $(this).find(".product-wrapper .progress"),
        i = $(this).find(".quantity"),
        o = $(this).find(".progress-bar"),
        a = i.html(),
        l = parseInt(o.css("width")),
        n = parseInt(s.css("width")),
        r = l + parseInt(a);
      r > n && (r = n);
      var c = (r / n) * 100;
      o.animate({ width: c + "%" }, 100);
    }),
    $("body:not(.rtl) .category_feature1").owlCarousel({
      items: 5,
      nav: !1,
      dots: !1,
      autoplay: !0,
      loop: !0,
      rtl: !1,
      autoplayHoverPause: !1,
      lazyLoad: !0,
      smartSpeed: 1e3,
      autoplayTimeout: 3e3,
      responsive: {
        100: { items: 1 },
        320: { items: 2 },
        481: { items: 3 },
        768: { items: 4 },
        1300: { items: 5 },
      },
    }),
    $("body.rtl .category_feature1").owlCarousel({
      items: 5,
      nav: !1,
      dots: !1,
      autoplay: !0,
      loop: !0,
      rtl: !1,
      autoplayHoverPause: !1,
      lazyLoad: !0,
      smartSpeed: 1e3,
      autoplayTimeout: 3e3,
      responsive: {
        100: { items: 1 },
        320: { items: 2 },
        481: { items: 3 },
        768: { items: 4 },
        1300: { items: 5 },
      },
    }),
    $("body:not(.rtl) .widget_top_rated_products .top-products").owlCarousel({
      items: 1,
      nav: !0,
      dots: !0,
      loop: !1,
      autoplay: !0,
      rtl: !1,
      responsive: { 1279: { items: 1 }, 600: { items: 1 } },
    }),
    $("body.rtl .widget_top_rated_products .top-products").owlCarousel({
      items: 1,
      nav: !0,
      dots: !0,
      loop: !1,
      autoplay: !0,
      rtl: !0,
      responsive: { 1279: { items: 1 }, 600: { items: 1 } },
    }),
    jQuery(".spr-summary-actions-newreview").on("click", function (t) {
      t.preventDefault(), jQuery(".spr-content").slideToggle("slow");
    }),
    $(
      ".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a,.pro_btn.add-to-compare .add-in-compare-js"
    ).click(function () {
      $(this).addClass("loading"),
        setTimeout(function () {
          $(
            ".pro_btn.quick-view-wrap > a,.pro_btn.add_tocart form > a, .pro_btn.add-to-compare .add-in-compare-js"
          ).removeClass("loading");
        }, 2e3);
    }),
    $(".headerbanner-close").on("click", function () {
      $(".ttcmstopbanner").slideToggle("slow", function () {}),
        jQuery("body").addClass("headerbanner-close");
    }),
    $("body:not(.template-index) .site-header .toggle_menu").hasClass(
      "current-close"
    ) && $(".tt-mega_menu").slideUp("2000"),
    $(".toggle_menu").click(function () {
      $(this).hasClass("default-open") && 992 > $(window).width()
        ? $(this).hasClass("current-close")
          ? ($(this).addClass("current-open"),
            $("body").addClass("menu-current-open"),
            $(this).removeClass("current-close"),
            $(".tt-mega_menu").slideToggle("2000"))
          : ($(this).removeClass("default-open"),
            $(this).addClass("current-open"),
            $("body").addClass("menu-current-open"),
            $(this).removeClass("current-close"),
            $(".tt-mega_menu").slideToggle("2000"))
        : $(this).hasClass("default-open")
        ? $(this).hasClass("current-close")
          ? ($(this).addClass("current-open"),
            $("body").addClass("menu-current-open"),
            $(this).removeClass("current-close"),
            $(".tt-mega_menu").slideToggle("2000"))
          : $(this).hasClass("current-open") &&
            ($(this).addClass("current-close"),
            $(this).removeClass("current-open"),
            $("body").removeClass("menu-current-open"),
            $(".tt-mega_menu").slideToggle("2000"))
        : $(this).hasClass("current-open")
        ? ($(this).addClass("current-close"),
          $("body").removeClass("menu-current-open"),
          $(this).removeClass("current-open"),
          $(".tt-mega_menu").slideToggle("2000"))
        : ($(this).addClass("current-open"),
          $(this).removeClass("current-close"),
          $("body").addClass("menu-current-open"),
          $(".tt-mega_menu").slideToggle("2000")),
        $(this).hasClass("default-open") &&
          !$(".sticky_header").hasClass("fixed") &&
          ($(this).addClass("current-close"),
          $(this).removeClass("default-open"),
          $(".tt-mega_menu").slideToggle("2000")),
        $(this).hasClass("default-open") &&
          $(".sticky_header").hasClass("fixed") &&
          ($(this).addClass("current-open"),
          $("body").addClass("menu-current-open"),
          $(this).removeClass("default-open"),
          $(".tt-mega_menu").slideDown("2000"));
    });
  var r = $("#cmsgallery .image-content");
  r.owlCarousel({
    items: 5,
    dots: !1,
    loop: !1,
    nav: !0,
    rewind: !1,
    autoplay: !1,
    responsive: {
      100: { items: 1 },
      315: { items: 2 },
      600: { items: 3 },
      992: { items: 4 },
      1300: { items: 5 },
    },
  });
  var c = window.pageYOffset;
  window.onscroll = function (t) {
    var s = window.pageYOffset;
    c > s
      ? (document.getElementById("header-sticky").style.top = "0")
      : $("body").hasClass("account-toggle") ||
        $("body").hasClass("menu_hover") ||
        $("body").hasClass("cart_toggle") ||
        $("body").hasClass("search_toggle") ||
        $("body").hasClass("menu-current-open")
      ? ((document.getElementById("header-sticky").style.top = "0"),
        t.stopPropagation())
      : (document.getElementById("header-sticky").style.top = "-100px"),
      (c = s);
  };
}),
  jQuery(window).scroll(function () {
    jQuery(document).height() > jQuery(window).height() &&
      (jQuery(window).scrollTop() > 100
        ? jQuery("#GotoTop").fadeIn()
        : jQuery("#GotoTop").fadeOut());
  }),
  jQuery(document).ready(function () {
    jQuery(".product-write-review").on("click", function (t) {
      t.preventDefault(),
        $("a[href='#tab-2']").trigger("click"),
        jQuery("html, body").animate(
          { scrollTop: jQuery(".product_tab_wrapper").offset().top - 150 },
          1e3
        );
    });
  }),
  jQuery(window).resize(function () {
    var t = $(window).width();
    $(".slider-content-main-wrap").css("width", t);
  }),
  $(document).ready(function () {
    height();
  }),
  $(window).resize(function () {
    height();
  }),
  $(window).scroll(function () {
    height();
  }),
  $(document).ready(function () {
    productcartsticky();
  }),
  jQuery(window).resize(function () {
    productcartsticky();
  }),
  jQuery(window).scroll(function () {
    productcartsticky();
  }),
  jQuery(document).ready(function () {
    footerToggle();
  }),
  jQuery(window).resize(function () {
    footerToggle();
  }),
  jQuery(window).load(function () {
    var t = $(".design_3 .product-wrapper-owlslider").height();
    $(".design_3 .product-information-inner.tt-scroll").css(
      "min-height",
      t + "px"
    );
  }),
  jQuery(window).resize(function () {
    footerToggle();
    var t = $(".design_3 .product-wrapper-owlslider").height();
    $(".design_3 .product-information-inner.tt-scroll").css(
      "min-height",
      t + "px"
    );
  }),
  $(window).scroll(function () {
    hb_animated_contents();
  }),
  $(window).load(function () {
    hb_animated_contents();
  }),
  jQuery(document).ready(function () {
    sidebarsticky();
  }),
  jQuery(window).resize(function () {
    sidebarsticky();
  }),
  jQuery(function () {
    if (!$("body").hasClass("fullnav-open")) {
      var t = function (t, s) {
        (this.el = t || {}),
          (this.multiple = s || !1),
          this.el
            .find("li.tt_mm_hassub .mobile-nav__sublist-trigger")
            .on(
              "click",
              { el: this.el, multiple: this.multiple },
              this.dropdown
            );
      };
      (t.prototype.dropdown = function (t) {
        var s = t.data.el;
        ($next = ($this = $(this)).next()).slideToggle(),
          $this.parent().toggleClass("open"),
          t.data.multiple ||
            s
              .find(".tt_menus_ul li.tt_mm_hassub .tt_sub_menu_wrap")
              .not($next)
              .slideUp()
              .parent()
              .removeClass("open");
      }),
        new t($(".tt_menus_ul"), !1);
    }
  }),
  jQuery(function () {
    if (!$("body").hasClass("fullnav-open")) {
      var t = function (t, s) {
        (this.el = t || {}),
          (this.multiple = s || !1),
          this.el
            .find("li.tt_mm_hassub .mobile-nav__sublist-trigger1")
            .on(
              "click",
              { el: this.el, multiple: this.multiple },
              this.dropdown
            );
      };
      (t.prototype.dropdown = function (t) {
        var s = t.data.el;
        ($next = ($this = $(this)).next()).slideToggle(),
          $this.parent().toggleClass("open"),
          t.data.multiple ||
            s
              .find(
                "li.tt_mm_hassub .tt_sub_menu_wrap .tt_sub_menu .tt_menu_item .tt_sub_menu_wrap"
              )
              .not($next)
              .slideUp()
              .parent()
              .removeClass("open");
      }),
        new t($(".tt_menus_ul"), !1);
    }
  }),
  jQuery(function () {
    if (!$("body").hasClass("fullnav-open")) {
      var t = function (t, s) {
        (this.el = t || {}),
          (this.multiple = s || !1),
          this.el
            .find("li.tt_mm_hassub .mobile-nav__sublist-trigger2")
            .on(
              "click",
              { el: this.el, multiple: this.multiple },
              this.dropdown
            );
      };
      (t.prototype.dropdown = function (t) {
        var s = t.data.el;
        ($next = ($this = $(this)).next()).slideToggle(),
          $this.parent().toggleClass("open"),
          t.data.multiple ||
            s
              .find(
                "li.tt_mm_hassub .tt_sub_menu_wrap .tt_sub_menu .tt_menu_item .tt_sub_menu_wrap .tt_menu_item .tt_sub_menu_wrap"
              )
              .not($next)
              .slideUp()
              .parent()
              .removeClass("open");
      }),
        new t($(".tt_menus_ul"), !1);
    }
  }),
  jQuery(function () {
    var t = function (t, s) {
      (this.el = t || {}),
        (this.multiple = s || !1),
        this.el
          .find(".toggle")
          .on("click", { el: this.el, multiple: this.multiple }, this.dropdown);
    };
    (t.prototype.dropdown = function (t) {
      var s = t.data.el;
      ($next = ($this = $(this)).next()).slideToggle(),
        $this.parent().toggleClass("active"),
        t.data.multiple ||
          s
            .find(".inline-list")
            .not($next)
            .slideUp()
            .parent()
            .removeClass("active");
    }),
      new t($(".footer-column"), !1);
  }),
  $("#AddToCart1").click(function () {
    $("#AddToCart").trigger("click");
  }),
  $(window).load(function () {
    $(".add-to-cart-sticky .qty-box-set .qnt_wrap .button").click(function () {
      var t = $(".add-to-cart-sticky .qty-box-set input.quantity").val();
      $(".quantity__input").val(t),
        $(".add-to-cart-sticky .qty-box-set .quantity").val(t);
    }),
      $(".product-information-inner .qty-box-set").click(function () {
        var t = $(".quantity__input").val();
        $(".quantity__input").val(t),
          $(".add-to-cart-sticky .qty-box-set .quantity").val(t);
      });
  });
